import { useMemo } from 'react';
import { ConfirmationDialogV2, ErpDataTableV2, ErpInputTableV2, BulkDeleteDialog } from '@/components/custom/erp';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';
import { HoaDonMuaDichVuSearchProvider, useHoaDonMuaDichVuPage } from './context';
import { ActionBar, FormDialog, SearchDialog } from './components';
import { getInputTableColumns } from './cols-definition';

function HoaDonMuaDichVuPageContent() {
  const page = useHoaDonMuaDichVuPage();
  const inputTableColumns = useMemo(() => getInputTableColumns(), []);

  return (
    <div className='flex h-screen w-screen flex-col overflow-hidden'>
      {page.searchDialog.open && (
        <SearchDialog
          open={page.searchDialog.open}
          onClose={page.searchDialog.onClose}
          onSearch={page.searchDialog.onSubmit}
          searchParams={page.searchDialog.searchParams}
        />
      )}

      {page.formDialog.open && (
        <FormDialog
          formMode={page.formDialog.formMode}
          open={page.formDialog.open}
          onClose={page.formDialog.onClose}
          initialData={
            page.formDialog.formMode === 'add' && !page.formDialog.isCopyMode ? undefined : page.formDialog.detail
          }
          onSubmit={page.formDialog.onSubmit}
          onAdd={page.formDialog.onAdd}
          onEdit={page.formDialog.onEdit}
          onDelete={page.formDialog.onDelete}
          onCopy={page.formDialog.onCopy}
        />
      )}

      {page.deleteDialog.open && (
        <ConfirmationDialogV2
          open={page.deleteDialog.open}
          onClose={page.deleteDialog.onClose}
          onConfirm={page.deleteDialog.onConfirm}
        />
      )}

      {page.bulkDeleteDialog.open && (
        <BulkDeleteDialog
          title='Hoá đơn mua dịch vụ'
          onClose={page.bulkDeleteDialog.onClose}
          columns={page.table.columns}
          dataRows={page.table.displayData}
          handleDeleteMany={page.bulkDeleteDialog.onDelete}
        />
      )}

      <div className={`flex h-full flex-col ${page.formDialog.open ? 'hidden' : ''}`}>
        <ActionBar
          onAdd={page.actions.handleAddClick}
          onEdit={page.actions.handleEditClick}
          onDelete={page.actions.handleDeleteClick}
          onCopy={page.actions.handleCopyClick}
          onSearch={page.actions.handleSearch}
          onRefresh={page.actions.handleRefresh}
          isEditDisabled={!page.selection.selectedObj}
        />

        <div data-excel-operation-overlay-root className='min-h-0 flex-1 overflow-hidden'>
          <ResizablePanelGroup direction='vertical' className='h-full overflow-hidden'>
            <ResizablePanel defaultSize={55} minSize={20}>
              <div data-perf-id='hdmh-dv-master-table' className='h-full w-full overflow-hidden'>
                {!page.actions.isExporting ? (
                  <ErpDataTableV2
                    tables={page.table.tables}
                    selectedRowId={page.selection.selectedRowIndex || undefined}
                    onRowClick={page.actions.handleRowClick}
                    pageSize={20}
                    totalItems={page.table.totalItems}
                    currentPage={page.table.currentPage}
                    onPageChange={page.table.onPageChange}
                    onSearchChange={page.table.onSearchChange}
                    loading={page.table.displayIsLoading}
                  />
                ) : null}
              </div>
            </ResizablePanel>

            <ResizableHandle withHandle className='bg-slate-200/80 hover:bg-slate-300' />

            <ResizablePanel defaultSize={45} minSize={20}>
              <div data-perf-id='hdmh-dv-bottom-detail-table' className='h-full overflow-hidden'>
                <ErpInputTableV2
                  rows={page.selection.selectedObj ? page.detailTable.rows : []}
                  columns={inputTableColumns}
                  showIndexColumn
                  actionsDisabled={page.formDialog.formMode === 'view' || !page.selection.selectedObj}
                  height='100%'
                  loading={page.table.displayIsLoading && !page.selection.selectedObj}
                />
              </div>
            </ResizablePanel>
          </ResizablePanelGroup>
        </div>
      </div>
    </div>
  );
}

export default function HoaDonMuaDichVuPage() {
  return (
    <HoaDonMuaDichVuSearchProvider>
      <HoaDonMuaDichVuPageContent />
    </HoaDonMuaDichVuSearchProvider>
  );
}
